import httpClient from "@/api/httpClient";
import PropertyAvailability from "@/model/PropertyAvailability";
import PropertyPage from "@/model/PropertyPage";
import PropertyResponse from "@/model/PropertyResponse";
import PropertySearchQuery from "@/model/PropertySearchQuery";

const PAGE_SIZE = 100;

function toSearchParams(query: PropertySearchQuery): URLSearchParams {
  const params = new URLSearchParams({ page: "0", size: String(PAGE_SIZE) });
  const set = (key: string, value: string | number | undefined) => {
    if (value !== undefined && value !== "") {
      params.set(key, String(value));
    }
  };

  set("city", query.city?.trim());
  set("placeId", query.placeId);
  if (query.checkIn && query.checkOut) {
    set("checkIn", query.checkIn);
    set("checkOut", query.checkOut);
  }
  set("guests", query.guests);
  set("propertyType", query.propertyType);
  set("minBedrooms", query.minBedrooms);
  set("minPrice", query.minPrice);
  set("maxPrice", query.maxPrice);
  (query.amenities ?? []).forEach((amenity) =>
    params.append("amenities", amenity)
  );
  if (query.bounds) {
    set("minLatitude", query.bounds.minLatitude);
    set("maxLatitude", query.bounds.maxLatitude);
    set("minLongitude", query.bounds.minLongitude);
    set("maxLongitude", query.bounds.maxLongitude);
  }

  return params;
}

function searchProperties(query: PropertySearchQuery): Promise<PropertyPage> {
  return httpClient.getJson<PropertyPage>(
    `/api/properties?${toSearchParams(query).toString()}`
  );
}

function getPropertyById(id: string): Promise<PropertyResponse> {
  return httpClient.getJson<PropertyResponse>(`/api/properties/${id}`);
}

function getAvailability(id: string): Promise<PropertyAvailability> {
  return httpClient.getJson<PropertyAvailability>(
    `/api/properties/${id}/availability`
  );
}

const propertiesApi = {
  searchProperties,
  getPropertyById,
  getAvailability,
};

export default propertiesApi;
